<template>
  <div id="indexEdit" class="indexEdit clearfix" v-if="mouldId != null">
    <div class="mould_choice clearfix">
      <div class="choice_title">选择模板</div>
      <div class="overAuto clearfix">
        <div class="mould_box clearfix" :class="{'active': mouldId==item.id}" v-for="(item,index) in mouldOptions"
          @click="mouldChange(item.id)" :title="item.name">
          <div class="box_img" :style="{'background-image': 'url('+item.img+')'}"></div>
          <div class="box_title">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="mould_show clearfix">
      <div class="show_header">
        <button :disabled="functionList.includes('companyServiceEditor')||!isLook?null:'disabled'" type="button"
          @click="goEditor()" class="ely-preview"
          :class="{'ButtonNoset':!functionList.includes('companyServiceEditor')||isLook || !$store.state.functionList.includes('companyServiceDevice')}"
          title="组态编辑"><span>组态编辑</span></button>
        <div class="right_header save" :class="{'isLook':isLook|| !$store.state.functionList.includes('companyServiceDevice')}" @click="Save()" title="保存">
          <span>保存</span>
        </div>
        <div class="right_header preview" :class="{'isLook':isLook|| !$store.state.functionList.includes('companyServiceDevice')}" @click="Preview()" title="预览">
          <span>预览</span>
        </div>
      </div>
      <el-form id="el-formAdd" ref="form" label-width="" :disabled="isLook|| !$store.state.functionList.includes('companyServiceDevice')">
        <div class="show_content clearfix"
          :class="{'backgroundBy456': mouldId == 4 || mouldId == 5 || mouldId == 6,'backgroundBy7': mouldId == 7 }">
          <div class="left" :style="leftStyle" v-if="mouldId != 8">

            <div class="left_top" v-if="mouldId == 3 || mouldId == 6">
              <div class="top-box OneDataSet">
                <div class="choice_data">
                  <el-form-item label="数据集：">
                    <div class="robotname clearfix" :title="titleName(left_top.one[0])">
                      <el-select v-model="left_top.one[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="top-box OneDataSet">
                <div class="choice_data">
                  <el-form-item label="数据集：">
                    <div class="robotname clearfix" :title="titleName(left_top.two[0])">
                      <el-select v-model="left_top.two[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="top-box OneDataSet">
                <div class="choice_data">
                  <el-form-item label="数据集：">
                    <div class="robotname clearfix" :title="titleName(left_top.three[0])">
                      <el-select v-model="left_top.three[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="top-box OneDataSet">
                <div class="choice_data">
                  <el-form-item label="数据集：">
                    <div class="robotname clearfix" :title="titleName(left_top.four[0])">
                      <el-select v-model="left_top.four[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="top-box OneDataSet" style="margin-right: 0">
                <div class="choice_data">
                  <el-form-item label="数据集：">
                    <div class="robotname clearfix" :title="titleName(left_top.five[0])">
                      <el-select v-model="left_top.five[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="left_top_2" v-if="mouldId == 7">
              <div class="top-box OneDataSet">
                <div class="choice_data">
                  <el-form-item label="数据集：">
                    <div class="robotname clearfix" :title="titleName(left_top_2.one[0])">
                      <el-select v-model="left_top_2.one[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="top-box OneDataSet">
                <div class="choice_data">
                  <el-form-item label="数据集：">
                    <div class="robotname clearfix" :title="titleName(left_top_2.two[0])">
                      <el-select v-model="left_top_2.two[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="top-box OneDataSet">
                <div class="choice_data">
                  <el-form-item label="数据集：">
                    <div class="robotname clearfix" :title="titleName(left_top_2.three[0])">
                      <el-select v-model="left_top_2.three[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="top-box OneDataSet" style="margin-right: 0">
                <div class="choice_data">
                  <el-form-item label="数据集：">
                    <div class="robotname clearfix" :title="titleName(left_top_2.four[0])">
                      <el-select v-model="left_top_2.four[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="left_top_3" v-if="mouldId == 7">
              <div class="top-box OneDataSet">
                <div class="choice_data">
                  <el-form-item label="数据集：">
                    <div class="robotname clearfix" :title="titleName(left_top_3.one[0])">
                      <el-select v-model="left_top_3.one[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="top-box OneDataSet">
                <div class="choice_data">
                  <el-form-item label="数据集：">
                    <div class="robotname clearfix" :title="titleName(left_top_3.two[0])">
                      <el-select v-model="left_top_3.two[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="top-box OneDataSet">
                <div class="choice_data">
                  <el-form-item label="数据集：">
                    <div class="robotname clearfix" :title="titleName(left_top_3.three[0])">
                      <el-select v-model="left_top_3.three[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="top-box OneDataSet" style="margin-right: 0">
                <div class="choice_data">
                  <el-form-item label="数据集：">
                    <div class="robotname clearfix" :title="titleName(left_top_3.four[0])">
                      <el-select v-model="left_top_3.four[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="left_center" :style="leftcenterStyle">
              <div class="center-box">
                <p>运维组态</p>
                <!--关联属性 多选-->
                <div class="settings_box_content clearfix" v-if="mouldId == 7">
                  <div class="content_name">
                    系统运行状态关联属性 :
                  </div>
                  <div class="content_body">
                    <el-cascader ref="spanSon" v-model="DeviceData" :options="DeviceOptions"
                      :props="{expandTrigger: 'hover',value:'id',label:'name',children:'children'}">
                    </el-cascader>
                  </div>
                </div>
              </div>

            </div>

            <div class="left_bottom" v-if="mouldId == 1 || mouldId == 4">
              <div class="bottom-box">
                <div class="choice_data">
                  <el-form-item label="数据集1：">
                    <div class="robotname clearfix" :title="titleName(left_bottom.one[0])">
                      <el-select v-model="left_bottom.one[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="数据集2：">
                    <div class="robotname clearfix" :title="titleName(left_bottom.one[1])">
                      <el-select v-model="left_bottom.one[1]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="数据集3：">
                    <div class="robotname clearfix" :title="titleName(left_bottom.one[2])">
                      <el-select v-model="left_bottom.one[2]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
                <div class="left_top_" v-if="mouldId == 4"></div>
                <div class="right_top_" v-if="mouldId == 4"></div>
                <div class="left_bottom_" v-if="mouldId == 4"></div>
                <div class="right_bottom_" v-if="mouldId == 4"></div>
              </div>
            </div>

          </div>
          <div class="right" v-if="mouldId != 3 && mouldId != 6&& mouldId != 8" :style="rightStyle">

            <div class="right_ right1 OneDataSet" v-if="mouldId != 1 && mouldId != 4 && mouldId != 7">
              <div class="choice_data">
                <el-form-item label="数据集1：">
                  <div class="robotname clearfix" :title="titleName(right.one[0])">
                    <el-select v-model="right.one[0]" placeholder="" @change="stepUpdata" clearable>
                      <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
            </div>

            <div class="right_ right2 OneDataSet" v-if="mouldId != 1 && mouldId != 4 && mouldId != 7">
              <div class="choice_data">
                <el-form-item label="数据集1：">
                  <div class="robotname clearfix" :title="titleName(right.two[0])">
                    <el-select v-model="right.two[0]" placeholder="" @change="stepUpdata" clearable>
                      <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
            </div>

            <div class="right_ right3" v-if="mouldId == 1 || mouldId == 4">
              <div class="choice_data">
                <el-form-item label="数据集1：">
                  <div class="robotname clearfix" :title="titleName(right.three[0])">
                    <el-select v-model="right.three[0]" placeholder="" @change="stepUpdata" clearable>
                      <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item label="数据集2：">
                  <div class="robotname clearfix" :title="titleName(right.three[1])">
                    <el-select v-model="right.three[1]" placeholder="" @change="stepUpdata" clearable>
                      <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item label="数据集3：">
                  <div class="robotname clearfix" :title="titleName(right.three[2])">
                    <el-select v-model="right.three[2]" placeholder="" @change="stepUpdata" clearable>
                      <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
            </div>

            <div class="right4" v-if="mouldId == 7">
              <div class="right4_ right4_left">
                <div class="choice_data">
                  <el-form-item label="数据集1：">
                    <div class="robotname clearfix" :title="titleName(right.six[0])">
                      <el-select v-model="right.six[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="right4_ right4_right">
                <div class="AlarmCount">报警统计</div>
              </div>
            </div>

            <div class="right_ right_center">
              <div class="choice_data">
                <el-form-item label="数据集1：">
                  <div class="robotname clearfix" :title="titleName(right.four[0])">
                    <el-select v-model="right.four[0]" placeholder="" @change="stepUpdata" clearable>
                      <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item label="数据集2：" v-if="mouldId != 7">
                  <div class="robotname clearfix" :title="titleName(right.four[1])">
                    <el-select v-model="right.four[1]" placeholder="" @change="stepUpdata" clearable>
                      <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item label="数据集3：" v-if="mouldId != 7">
                  <div class="robotname clearfix" :title="titleName(right.four[2])">
                    <el-select v-model="right.four[2]" placeholder="" @change="stepUpdata" clearable>
                      <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
            </div>

            <div class="right_ right_bottom">
              <div class="choice_data">
                <el-form-item label="数据集1：">
                  <div class="robotname clearfix" :title="titleName(right.five[0])">
                    <el-select v-model="right.five[0]" placeholder="" @change="stepUpdata" clearable>
                      <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item label="数据集2：" v-if="mouldId != 7">
                  <div class="robotname clearfix" :title="titleName(right.five[1])">
                    <el-select v-model="right.five[1]" placeholder="" @change="stepUpdata" clearable>
                      <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item label="数据集3：" v-if="mouldId != 7">
                  <div class="robotname clearfix" :title="titleName(right.five[2])">
                    <el-select v-model="right.five[2]" placeholder="" @change="stepUpdata" clearable>
                      <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
            </div>

            <div class="right_last" v-if="mouldId == 7">
              <div class="right_last_ right_last_1">
                <div class="choice_data">
                  <el-form-item label="数据集1：">
                    <div class="robotname clearfix" :title="titleName(right.seven[0])">
                      <el-select v-model="right.seven[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="right_last_ right_last_2">
                <div class="choice_data">
                  <el-form-item label="数据集1：">
                    <div class="robotname clearfix" :title="titleName(right.eight[0])">
                      <el-select v-model="right.eight[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="right_last_ right_last_3">
                <div class="choice_data">
                  <el-form-item label="数据集1：">
                    <div class="robotname clearfix" :title="titleName(right.nine[0])">
                      <el-select v-model="right.nine[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="right_last_ right_last_4" style="margin-right: 0 !important;">
                <div class="choice_data">
                  <el-form-item label="数据集1：">
                    <div class="robotname clearfix" :title="titleName(right.ten[0])">
                      <el-select v-model="right.ten[0]" placeholder="" @change="stepUpdata" clearable>
                        <el-option v-for="(item,index) in DataSetList" class="classifyOpa" :key="index"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div class="mould8 clearfix" v-if="mouldId==8">
            <div class="left-box f-l">
              <p class="list-title top-20">空压机当前调节状态</p>
              <div style="width: 100%; display: flex;">
                <div class="datas-box">
                  <el-form-item label="设备属性：">
                    <el-col :span="14"> <!-- @change="changeRate('cascader2',r,real)" -->
                      <el-cascader v-model="mouldData.stateData" size="small" :options="DeviceOptions" :props="{expandTrigger: 'hover',value:'id',label:'name',children:'children2'}">
                      </el-cascader>
                    </el-col>
                  </el-form-item>
                </div>
              </div>
              <p class="list-title">设备列表 <span class="f-r"
                  style="margin-right: 35px;font-weight: 500;font-size: 14px; color: #5088e4;" @click="add(1)">添加设备</span></p>
              <div class="scroll">
                <div class="devices-box" v-for="(device,d) in mouldData.deviceList" :key='d'
                  :style="{'margin-right':i%3==0?'0px':'21px'}">
                  <p class="p-r">
                    <el-form-item label="关联设备：">
                      <el-col :span="13">
                        <el-select placeholder="请选择设备" size="small" clearable v-model="device.deviceCode" @change="changeDevice($event,device)">
                           <el-option v-for="item in DeviceOptions" class="classifyOpa" :key="item.id"
                             :label="item.name" :value="item.code" v-if="item.name!='虚拟设备'">
                           </el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                    <img :src="del" class="close-img" v-if="!$store.state.isLook && $store.state.functionList.includes('companyServiceDevice')" :ref="'device'+d" @click="delDevice2(d)" @mouseover="imgHover('device'+d)" @mouseout="disHover('device'+d)">
                    <img :src="del3" class="close-img" v-if="$store.state.isLook || !$store.state.functionList.includes('companyServiceDevice')" style="cursor: not-allowed;">
                  </p>
                  <el-form-item label="设备开关机状态：">
                    <el-col :span="11">
                      <el-select placeholder="请选择设备属性" size="small" clearable v-model="device.offlineCode">
                        <el-option v-for="item in device.attrOptions" class="classifyOpa" :key="item.identifier"
                          :label="item.name" :value="item.identifier">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="设备图片：" :class="{'height-32':!device.image}">
                    <el-col :span="15">
                      <!-- <el-input class="device-img-input" clearable readonly :value="device.imageName"></el-input> -->
                      <div class="device-img-input" :class="{'disable-img':$store.state.isLook || !$store.state.functionList.includes('companyServiceDevice')}" @click="elitImage($event,device)">{{getImageName(device.image)}}</div>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="关联进度：">
                    <el-col :span="15">
                      <el-select placeholder="请选择设备属性" size="small" clearable v-model="device.paceCode">
                        <el-option v-for="item in device.attrOptions" class="classifyOpa" :key="item.identifier"
                          :label="item.name" :value="item.identifier">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="设备属性：">
                    <el-col :span="15">
                      <el-select placeholder="请选择设备属性" size="small" clearable v-model="device.identifier1" @change="setAttr($event,device,'propertyName1')">
                        <el-option v-for="item in device.attrOptions" class="classifyOpa" :key="item.identifier"
                          :label="item.name" :value="item.identifier">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="设备属性：">
                    <el-col :span="15">
                      <el-select placeholder="请选择设备属性" size="small" clearable v-model="device.identifier2" @change="setAttr($event,device,'propertyName2')">
                        <el-option v-for="item in device.attrOptions" class="classifyOpa" :key="item.identifier"
                          :label="item.name" :value="item.identifier">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                </div>
              </div>
              <p class="list-title top-20">数据曲线1</p>
              <div style="width: 100%; display: flex;">
                <div class="datas-box" v-for="(curve,c) in mouldData.curveOneData" :key='c'>
                  <el-form-item label="数据集：">
                    <el-col :span="16">
                      <el-select placeholder="请选择数据集" size="small" clearable v-model="curve.id">
                        <el-option v-for="item in DataSetList" class="classifyOpa" :key="item.id"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="centent-box f-l">
              <p class="list-title">数据曲线2</p>
              <div style="width: 100%; display: flex;flex-wrap: wrap;height: 27.5%;">
                <div class="datas-box" style="width: 100%;height: 39%;">
                  <el-form-item label="露点数据：">
                    <el-col :span="15">
                      <el-select placeholder="请选择数据集" size="small" clearable v-model="mouldData.curveTwoData.dewId">
                        <el-option v-for="item in DataSetList" class="classifyOpa" :key="item.id"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                </div>
                <div class="datas-box" style="width: 100%;height: 39%;">
                  <el-form-item label="流量数据：">
                    <el-col :span="15">
                      <el-select placeholder="请选择数据集" size="small" clearable v-model="mouldData.curveTwoData.flowId">
                        <el-option v-for="item in DataSetList" class="classifyOpa" :key="item.id"
                          :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                </div>
              </div>
              <p class="list-title">设备能耗</p>
              <div class="sulv-box2" style="height: 15%;overflow: hidden;">
                <p class="p-r">
                  <el-form-item label="小时能耗：">
                    <el-col :span="14"> <!-- @change="changeRate('cascader2',r,real)" -->
                      <el-cascader v-model="mouldData.energyData.hourCode" size="small" :options="DeviceOptions" :props="{expandTrigger: 'hover',value:'id',label:'name',children:'children2'}">
                      </el-cascader>
                    </el-col>
                  </el-form-item>
                </p>
                <p class="p-r">
                  <el-form-item label="当天能耗：">
                    <el-col :span="14"> <!-- @change="changeRate('cascader2',r,real)" -->
                      <el-cascader v-model="mouldData.energyData.DayCode" size="small" :options="DeviceOptions" :props="{expandTrigger: 'hover',value:'id',label:'name',children:'children2'}">
                      </el-cascader>
                    </el-col>
                  </el-form-item>
                </p>
              </div>
              <p class="list-title">变频机运行速率<span class="f-r" style="margin-right: 35px;font-weight: 500;font-size: 14px; color: #5088e4;" @click="add(2)">添加设备</span></p>
              <div class="sulv-box3">
                <p class="p-r" v-for="(rate,r) in mouldData.rateData" :key="r">
                  <el-form-item label="设备属性：">
                    <el-col :span="14">
                      <el-cascader v-model="rate.value" ref="cascader1" size="small" @change="changeRate('cascader1',r,rate)" :options="DeviceOptions" :props="{expandTrigger: 'hover',value:'id',label:'name',children:'children2'}">
                      </el-cascader>
                    </el-col>
                  </el-form-item>
                  <img :src="del" class="close-img" v-if="!$store.state.isLook && $store.state.functionList.includes('companyServiceDevice')" :ref="'dev'+r" @click="delDevice(r)" @mouseover="imgHover('dev'+r)" @mouseout="disHover('dev'+r)">
                  <img :src="del3" class="close-img" v-if="$store.state.isLook || !$store.state.functionList.includes('companyServiceDevice')" style="cursor: not-allowed;">
                </p>
              </div>
            </div>

            <div class="right-box f-l">
              <p class="list-title">实时数据<span class="f-r"
                  style="margin-right: 35px;font-weight: 500;font-size: 14px; color: #5088e4;" @click="add(3)">添加设备</span></p>
              <div class="sulv-box2" style="height: 47%;">
                <p class="p-r" v-for="(real,r) in mouldData.realTimeData" :key="r">
                  <el-form-item label="设备属性：">
                    <el-col :span="14">
                      <el-cascader v-model="real.value" ref="cascader2" size="small" @change="changeRate('cascader2',r,real)" :options="DeviceOptions" :props="{expandTrigger: 'hover',value:'id',label:'name',children:'children2'}">
                      </el-cascader>
                    </el-col>
                  </el-form-item>
                  <img :src="del" class="close-img" v-if="!$store.state.isLook && $store.state.functionList.includes('companyServiceDevice')" :ref="'real'+r" @click="delRealTime(r)" @mouseover="imgHover('real'+r)" @mouseout="disHover('real'+r)">
                  <img :src="del3" class="close-img" v-if="$store.state.isLook || !$store.state.functionList.includes('companyServiceDevice')" style="cursor: not-allowed;">
                </p>
              </div>
              <p class="list-title">统计数据<span class="f-r"
                  style="margin-right: 35px;font-weight: 500;font-size: 14px; color: #5088e4;" @click="add(4)">添加设备</span></p>
              <div class="sulv-box3">
                <p class="p-r" v-for="(statistics,s) in mouldData.statisticsData" :key="s">
                  <el-form-item label="设备属性：">
                    <el-col :span="14">
                      <el-cascader v-model="statistics.value" ref="cascader3" size="small" @change="changeRate('cascader3',s,statistics)" :options="DeviceOptions" :props="{expandTrigger: 'hover',value:'id',label:'name',children:'children2'}">
                      </el-cascader>
                    </el-col>
                  </el-form-item>
                  <img :src="del" class="close-img" v-if="!$store.state.isLook && $store.state.functionList.includes('companyServiceDevice')" :ref="'statis'+s" @click="delStatisticsData(s)" @mouseover="imgHover('statis'+s)" @mouseout="disHover('statis'+s)">
                  <img :src="del3" class="close-img" v-if="$store.state.isLook || !$store.state.functionList.includes('companyServiceDevice')" style="cursor: not-allowed;">
                </p>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="popupT">
      <!-- 验证码授权 -->
      <div class="popupT-clear" v-show='functionShow' id="privilege"
        style="position: fixed; height: 349px;text-align: left;margin-left: -216px">
        <div class="popupT-title">
          获取验证码授权<i><img :src="notes" title="提示" style="position: relative; left: 5px; top: 3px;"></i><i
            class="el-icon-circle-close close" @click="closeT('functionShow')" id="closeClear3"></i>
        </div>
        <div class="popupT-lab">
          手机号：
          <el-input disabled v-model="phone">{{phone}}</el-input>
        </div>
        <div class="popupT-lab clearfix">
          <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
          <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode"
            @submit.native.prevent>
            <el-form-item prop="verifyCode">
              <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege"
                v-model='verifyForm.verifyCode' maxlength="4"
                @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
            </el-form-item>
          </el-form>
          <div class="code-box">
            <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
            <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
          </div>
        </div>
        <div class="popupT-lab">
          <p class="btn-box" style="margin-top: 26px;text-align: center;">
            <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
            <el-button @click="closeT('functionShow')" id="closeClear4">取消</el-button>
          </p>
        </div>
      </div>
    </div>
    <div class="imageBox" :style="[{left:boxLeft+'px'},{top:boxTop+'px'}]" v-show="imgShow">
      <i class="el-icon-circle-close close" @click.stop="imgShow=false" ></i>
      <div class="img-list">
        <div class="img-item p-r" v-for="item in imageList" :key="item.id" @click.stop="changeImg(item)">
          <img :src="item.image">
          <p>{{item.name}}</p>
        </div>
      </div>
    </div>
    <div class="img-mask" v-show="imgShow"  @click="imgShow=false" ></div>
  </div>
</template>
<script>
  export default {
    data() {

      return {
        del:require('@/assets/image/organize/delete.png'),
        del2:require('@/assets/image/organize/delete2.png'),
        del3:require('@/assets/image/organize/delete3.png'),
        del4:require('@/assets/image/organize/delete4.png'),
        imageList:[],
        //设备列表 以及关联属性(布尔值)
        DeviceOptions: [],

        //当前设置系统运行状态的model
        DeviceData: [],
        deviceObj:{},
        boxLeft:0,
        boxTop:0,
        imgShow:false,
        //当前组态类型 1为正常组态, 2为增强型组态(3D)
        type: 1,
        // 模板8数据
        mouldData:{
          stateData:[],
          // 设备列表
          deviceList:[
            {deviceCode:null,paceCode:null,identifier1:null,identifier2:null,attrOptions:[]},
            {deviceCode:null,paceCode:null,identifier1:null,identifier2:null,attrOptions:[]},
            {deviceCode:null,paceCode:null,identifier1:null,identifier2:null,attrOptions:[]},
            {deviceCode:null,paceCode:null,identifier1:null,identifier2:null,attrOptions:[]},
            {deviceCode:null,paceCode:null,identifier1:null,identifier2:null,attrOptions:[]},
            {deviceCode:null,paceCode:null,identifier1:null,identifier2:null,attrOptions:[]}
          ],
          curveOneData:[{id:null},{id:null}],     //曲线数据1
          curveTwoData:{dewId:null,flowId:null},  //曲线数据2
          rateData:[{value:null}],        //加载速率
          realTimeData:[{value:null}],    //实时
          statisticsData:[{value:null}],  //统计
          energyData:{hourCode:null,DayCode:null}
        },
        VirtualDevice:{},
        //模板列表
        mouldOptions: [{
          id: 1,
          name: '模板一',
          img: require('../../assets/image/indexEditor/mould/mould1-1.png'),
        }, {
          id: 2,
          name: '模板二',
          img: require('../../assets/image/indexEditor/mould/mould2-1.png'),
        }, {
          id: 3,
          name: '模板三',
          img: require('../../assets/image/indexEditor/mould/mould3-1.png'),
        }, {
          id: 4,
          name: '模板四',
          img: require('../../assets/image/indexEditor/mould/mould4-1.png'),
        }, {
          id: 5,
          name: '模板五',
          img: require('../../assets/image/indexEditor/mould/mould5-1.png'),
        }, {
          id: 6,
          name: '模板六',
          img: require('../../assets/image/indexEditor/mould/mould6-1.png'),
        }, {
          id: 7,
          name: '模板七',
          img: require('../../assets/image/indexEditor/mould/mould7-1.png'),
        }, {
          id: 8,
          name: '模板八',
          img: require('../../assets/image/indexEditor/mould/mould8-1.jpg'),
        }, ],

        mouldId: null, //当前选中模板id

        step: 0, //当前操作步数

        //数据集列表
        DataSetList: [
          /*{
          					id: 1,
          					name: '测试1'
          				}, {
          					id: 2,
          					name: '测试2'
          				}, {
          					id: 3,
          					name: '测试3'
          				}, {
          					id: 4,
          					name: '测试4'
          				}, {
          					id: 5,
          					name: '测试5'
          				}*/
        ],

        //当前操作的模型 (用于页面双向绑定)
        left_top: {
          one: [], //1
          two: [], //1
          three: [], //1
          four: [], //1
          five: [], //1
        },
        left_top_2: {
          one: [], //1
          two: [], //1
          three: [], //1
          four: [], //1
        },
        left_top_3: {
          one: [], //1
          two: [], //1
          three: [], //1
          four: [], //1
        },
        left_bottom: {
          one: [], //3
        },
        right: {
          one: [], //1
          two: [], //1
          three: [], //3
          four: [], //3
          five: [], //3
          six: [], //1
          seven: [], //1
          eight: [], //1
          nine: [], //1
          ten: [], //1
        },

        //当前操作的模型 (用于转换数据格式 保存 获取)
        mouldBox: [{
          name: 'left_top',
          children: [{
            name: 'one'
          }, {
            name: 'two'
          }, {
            name: 'three'
          }, {
            name: 'four'
          }, {
            name: 'five'
          }]
        }, {
          name: 'left_top_2',
          children: [{
            name: 'one'
          }, {
            name: 'two'
          }, {
            name: 'three'
          }, {
            name: 'four'
          }]
        }, {
          name: 'left_top_3',
          children: [{
            name: 'one'
          }, {
            name: 'two'
          }, {
            name: 'three'
          }, {
            name: 'four'
          }]
        }, {
          name: 'left_bottom',
          children: [{
            name: 'one'
          }]
        }, {
          name: 'right',
          children: [{
            name: 'one'
          }, {
            name: 'two'
          }, {
            name: 'three'
          }, {
            name: 'four'
          }, {
            name: 'five'
          }, {
            name: 'six'
          }, {
            name: 'seven'
          }, {
            name: 'eight'
          }, {
            name: 'nine'
          }, {
            name: 'ten'
          }]
        }],

        //获取数据集列表定时器 (因为consoleIndex获取用户信息的接口与当前数据集列表接口不同步)
        getCompanyCode: null,

        //企业运维屏信息
        CompanyScreen: {},

        rules: {
          verifyCode: [{
            message: '请输入验证码',
            required: true,
            trigger: 'blur'
          }]
        },
        notes: require('@/assets/image/organize/notes.png'),
        verifyForm: {
          verifyCode: '',
        },
        functionShow: false,
        VerifyArr: [],
        verifyCode: '',
        second: 60,
        getCodeShow: true,
        countdownShow: false,
        phone: '',
        time: null,
      }
    },
    computed: {
      getImageName(){
        return (url)=>{
          var obj = this.imageList.filter(i=>i.image==url)[0]
          if(obj){
            return obj.name
          }else{
            return ''
          }
        }
      },
      DeviceDataTitle() {
        return (arr) => {
          if (arr.length == 0 || !arr || this.DeviceOptions.length == 0) return;
          let device = this.DeviceOptions.filter(item => item.id == arr[0])[0];
          if (!device.children) return
          let attr = device.children.filter(item => item.id == arr[1])[0];
          attr = attr || {};
          attr.name = attr.name || ''
          return device.name + ' / ' + attr.name
        }
      },
      isLook() {
        return this.$store.state.isLook;
      },
      titleName() {
        return (id) => {
          if (id) {
            return this.DataSetList.filter(item => item.id == id)[0] ? this.DataSetList.filter(item => item.id == id)
              .name : ''
          } else {
            return ''
          }
        }
      },
      leftcenterStyle() {
        if (this.mouldId == 1 || this.mouldId == 4) {
          return {
            top: '41px',
          }
        } else if (this.mouldId == 2 || this.mouldId == 5) {
          return {
            top: '41px',
            bottom: '60px',
          }
        } else if (this.mouldId == 3 || this.mouldId == 6) {
          return {
            bottom: '39px',
            right: '31px'
          }
        } else if (this.mouldId == 7) {
          return {
            bottom: '60px',
            top: '265px'
          }
        }
      },
      leftStyle() {
        if (this.mouldId == 3 || this.mouldId == 6) {
          return {
            right: 0,
          }
        } else if (this.mouldId == 7) {
          return {
            right: '729px'
          }
        }
      },
      rightStyle() {
        if (this.mouldId == 7) {
          return {
            width: '729px',
          }
        }
      },
      companyId() {
        return this.$store.state.companyId;
      },
      companyCode() {
        return this.$store.state.companyCode;
      },
      functionList() {
        return this.$store.state.functionList;
      },
    },
    components: {

    },
    created() {
      //设置头部
      this.$store.state.headerActive = 5;
      this.getImage()
    },
    mounted() {
      /*window.onbeforeunload = () => {
      	if(this.step > 0){
      		return '当前编辑的版本尚未保存，是否确定离开?'
      	}
      };*/
      this.getCompanyCode = setInterval(() => {
        if (this.companyCode) {
          clearInterval(this.getCompanyCode)
          /*获取数据集列表*/
          this.get('/Dataset/getList', {
            code: this.companyCode
          }).then(async (res) => {
            if (res.success) {
              this.DataSetList = res.result;
              let ret = await this.getHistoryData();
              this.DeviceOptions = ret.result.filter(item => item.propertySet.split(',')[0] != '');
              await this.realDeviceinit();
              this.$forceUpdate()
              this.initScree();
              this.getVirtualDevice()
            } else {
              this.$message({
                message: `获取数据集列表失败：${res.message}`,
                type: 'warning'
              });
            }
          })

        }
      }, 500)
      this.phone = this.hidePhone(this.$store.state.userData.mobile);
      this.getData();
    },
    methods: {
      elitImage(e,obj){
        this.deviceObj= obj
        this.boxLeft = e.pageX,
        this.boxTop = e.pageY-250
        this.imgShow = true
      },
      changeImg(obj){
        this.deviceObj.image = obj.image
        this.imgShow = false
      },
      getImage(){
        this.get('/Control/getList').then(res=>{
          if(res.success){
            this.imageList = res.result
          }
        })
      },
      imgHover(ref){
        if(this.cssType==1){
          this.$refs[ref][0].src = this.del4
        }else{
          this.$refs[ref][0].src = this.del2
        }
      },
      disHover(ref){
        this.$refs[ref][0].src = this.del
      },
      // 修改属性
      setAttr(v,obj,key){
        obj[key] = obj.attrOptions.filter(i => i.identifier == v)[0].name
      },
      // 获取虚拟设备
      getVirtualDevice(){
        this.get('/VirtualDevice/get',{companyId:this.$store.state.companyId}).then(res=>{
          if(res.success){
            this.VirtualDevice = res.result
            this.VirtualDevice.name = '虚拟设备'
			if(!this.VirtualDevice.id&&this.VirtualDevice.id!=0){ return }
            this.get('/VirtualDevice/getPropertyList',{deviceId:this.VirtualDevice.id,companyId:this.$store.state.companyId}).then(res=>{
              if(res.success){
                let arr = res.result
                for(let a of arr){
                  a.id = a.code
                }
                this.VirtualDevice.children2 = arr
                if(this.mouldId==8){
                  this.DeviceOptions.unshift(this.VirtualDevice)
                }
                  console.log(this.DeviceOptions)
              }else{
                this.$message({
                  message: `获取虚拟设备属性失败：${res.message}`,
                  type: 'warning'
                });
              }
            })
          }else{
            this.$message({
              message: `获取虚拟设备失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      // 删除数据
      delDevice(i,type){
        // if(this.mouldData.rateData.length>1){
          this.mouldData.rateData.splice(i,1)
        // }
      },
      delDevice2(i,type){
        // if(this.mouldData.rateData.length>1){
          this.mouldData.deviceList.splice(i,1)
        // }
      },
      delRealTime(i,type){
        // if(this.mouldData.rateData.length>1){
          this.mouldData.realTimeData.splice(i,1)
        //
      },
      delStatisticsData(i){
        this.mouldData.statisticsData.splice(i,1)
      },
      // 添加数据
      add(i){
        if(i==1){
          this.mouldData.deviceList.push({deviceCode:null,paceCode:null,identifier1:null,identifier2:null,attrOptions:[]},)
        }else if(i==2){
          this.mouldData.rateData.push({value:null})
        }else if(i==3){
          this.mouldData.realTimeData.push({value:null})
        }else{
          this.mouldData.statisticsData.push({value:null})
        }

      },
      // 修改设备
      changeRate(refName,i,obj){
        let node=this.$refs[refName][i].getCheckedNodes()[0]
        obj.name = node.label
        obj.unit = node.data.unit
        obj.deviceName = node.parent.label
      },
      // 修改设备
      changeDevice(e,item,noset){
        let deviceOptions = this.DeviceOptions.filter(obj => obj.code == e)[0]
        if(deviceOptions){
          item.name = deviceOptions.name
          item.attrOptions = deviceOptions.children2
        }
        if(!noset){
          item.paceCode=null,
          item.identifier1=null,
          item.identifier2=null
        }
      },
      /*获取指定公司的设备列表*/
      getHistoryData() {
        let self = this;
        return new Promise((resolve, reject) => {
          self.get('/Device/getList', {
            companyId: self.companyId
          }).then((res) => {
            if (res.success == true) {
              resolve(res)
            }
          })
        })
      },

      /*配置设备列表*/
      realDeviceinit() {
        let self = this;
        return new Promise(async (resolve, reject) => {
          let index = 0;
          if (self.DeviceOptions.length == 0) resolve();
          for (let DeviceOptions of self.DeviceOptions) {
            let propList = DeviceOptions.propertySet.split(','); //属性数组
            let res = await this.getByDeviceCode(DeviceOptions.code)
            if (res.success == true) {
              let data = JSON.parse(res.result).properties;
              let arr = [],arr2=[];

              for (let list of propList) {
                for (let dataList of data) {
                  if ((list == dataList.identifier) && (dataList.dataType.type == 'bool')) {
                    dataList.id = dataList.identifier + '-' + DeviceOptions.code
                    arr.push(dataList);
                  }
                  if(list == dataList.identifier){
                    var data2 = this.clone(dataList)
                    data2.id = data2.identifier
                    arr2.push(data2);
                  }
                }
              }
              DeviceOptions.children = arr
              DeviceOptions.children2 = arr2
            }
            index++;
            if (index == this.DeviceOptions.length) {
              this.$forceUpdate()
              resolve();
            }
          }
        });
      },

      /*通过设备code获取属性*/
      getByDeviceCode(code) {
        let self = this;
        return new Promise((resolve, reject) => {
          self.get('/ProductFeature/getByDeviceCode', {
            code: code
          }).then((res) => {
            resolve(res)
          })
        })
      },

      /*验证码*/
      getCode() {
        // 获取验证码
        this.get('/UserProfile/sendVerifyCode').then((res) => {
          if (res.success) {
            this.getCodeShow = false
            this.countdownShow = true
            const TIME_COUNT = 60;
            this.$message({
              message: '验证码发送成功',
              type: 'success'
            });
            if (!this.timer) {
              this.second = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.second > 0 && this.second <= TIME_COUNT) {
                  this.second--;
                } else {
                  this.getCodeShow = true;
                  this.countdownShow = false;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000)
            }
          } else {
            this.$message({
              message: `验证码发送失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      Privilege() {
        // 用户提权
        this.$refs.verifyCode.validate((valid) => {
          if (valid) {
            this.post('/UserProfile/privilege', {
              verifyCode: this.verifyForm.verifyCode
            }).then(res => {
              if (res.success) {
                this.$message({
                  message: '提权成功',
                  type: 'success'
                })
                this.VerifyArr.splice(this.VerifyArr.indexOf(11), 1)
                localStorage.setItem('verifyCodeModule', this.VerifyArr)
                this.$store.state.mask = false
                this.functionShow = false
                this.getCodeShow = true;
                this.countdownShow = false;
                clearInterval(this.timer);
                this.timer = null;
                this.verifyForm.verifyCode = ''
              } else {
                this.$message({
                  message: `提权失败：${res.message}`,
                  type: 'warning'
                })
              }
            })
          }
        })
      },
      closeT() {
        this.functionShow = false;
        this.$store.state.mask = false;
        this.verifyForm.verifyCode = ''
      },
      getData() {
        //获取系统配置
        this.VerifyArr = localStorage.getItem('verifyCodeModule').split(',').map(Number)
      },
      /*验证码结束*/

      /*操作步数更新*/
      stepUpdata() {
        console.log(this.right.five,this.DataSetList)
        this.step++;
      },

      /*获取企业运维屏*/
      initScree() {
        let self = this;
        this.get('/CompanyScreen/get', {
          companyId: this.companyId
        }).then((res) => {
          if (res.success) {
            this.CompanyScreen = res.result;
            if (res.result.layout) {
              this.mouldId = res.result.layout;
            } else {
              this.mouldId = 1;
            }

            this.$nextTick(() => {
              if (this.$refs.overAuto) {
                this.$refs.overAuto.scrollTop = this.mouldOptions.filter(item => item.id == this.mouldId)[0]
                  .scrollTop;
              }
            })

            this.type = res.result.type ? res.result.type : 1;
            if(this.mouldId==8){
              this.$parent.changeHeight(880)
              this.mouldData = res.result.items[0]
              for(let obj of this.mouldData.deviceList){
                if(obj.deviceCode){
                  this.changeDevice(obj.deviceCode,obj,true)
                }
              }
            }
            if (this.CompanyScreen.items&&this.mouldId!=8) {
              if (this.CompanyScreen.items.length > 0) {
                /*初始化遍历*/
                let index = 0;
                for (let mouldBox of this.mouldBox) {
                  for (let children of mouldBox.children) {
                    if (res.result.items[index]) {
                      if (res.result.items[index].type != 6) {
                        let arr = res.result.items[index].value.split(',');
                        let arrOther = [];
                        for (let ar of arr) {
                          if (ar == '') {
                            arrOther.push(ar)
                          } else {
                            if (this.DataSetList.filter(item => item.id == ar).length == 0) {
                              arrOther.push('')
                            } else {
                              arrOther.push(Number(ar))
                            }
                          }
                        }
                        this[mouldBox.name][children.name] = arrOther;
                      }
                    }
                    index++;
                  }
                }
                let deviceArr = res.result.items.filter(item => item.type == 6);
                if (deviceArr.length != 0) {
                  this.DeviceData = JSON.parse(deviceArr[0].value).arr;
                }

              }
            }
            this.$forceUpdate()
          } else {
            this.$message({
              message: `获取企业运维屏失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },

      /*保存*/
      Save() {
        let self = this;
        if (self.isLook || !this.$store.state.functionList.includes('companyServiceDevice')) return;
        if (self.VerifyArr.includes(11)) {
          self.functionShow = true;
          self.$store.state.mask = true;
          return
        }
        let obj = {
          id: self.CompanyScreen.id,
          companyId: self.companyId,
          name: self.CompanyScreen.name,
          layout: self.mouldId,
          type: self.type,
          style: ''
        };
        let items = [];
        // 不是模板8走原步骤
        if(this.mouldId!=8){
          for (let a of self.mouldBox) {
            for (let b of a.children) {
              if (a.name != 'left_center') {
                items.push({
                  type: 1,
                  value: self[a.name][b.name].toString()
                })
              }
            }
          }

          /*添加系统运行状态关联属性*/
          if (self.DeviceData.length != 0) {
            let specs = this.DeviceOptions.filter(i => i.code == self.DeviceData[1].split('-')[1])[0].children.filter(p => p.id == self.DeviceData[1])[0].dataType.specs;
            let attr = {
              specs: specs,
              arr: self.DeviceData
            }
            items.push({
              type: 6,
              value: JSON.stringify(attr)
            })
          }
          // 模板8
        }else{
          let data = {
            stateData:this.mouldData.stateData,
            energyData:this.mouldData.energyData,
            deviceList:[],
            curveOneData:this.mouldData.curveOneData,
            curveTwoData:this.mouldData.curveTwoData,
            rateData:this.mouldData.rateData,
            realTimeData:this.mouldData.realTimeData,
            statisticsData:this.mouldData.statisticsData
          }
          for(let dev of this.mouldData.deviceList){
            if(dev.deviceCode){
              let devobj = {
                deviceCode:dev.deviceCode,
                name:dev.name,
                paceCode:dev.paceCode,
                identifier1:dev.identifier1,
                identifier2:dev.identifier2,
                propertyName1:dev.propertyName1,
                propertyName2:dev.propertyName2,
                offlineCode:dev.offlineCode,
                image:dev.image
              }
              data.deviceList.push(devobj)
            }else{
              let devobj = {
                deviceCode:null,
                name:null,
                paceCode:null,
                identifier1:null,
                identifier2:null,
              }
              data.deviceList.push(devobj)
            }
          }
          if(data.energyData.hourCode&&data.energyData.hourCode.length>0){
            let list = this.DeviceOptions.filter(i=>i.id==data.energyData.hourCode[0])[0]
            data.energyData.unit = list.name=="虚拟设备"?list.children2.filter(i=>i.code==data.energyData.hourCode[1])[0].unit:list.children2.filter(i=>i.identifier==data.energyData.hourCode[1])[0].dataType.specs.unit
          }
          items.push(data)
        }
        console.log(items)
        obj.items = items;
        return
        self.postNoJson('/CompanyScreen/set', obj).then((res) => {
          if (res.success) {
            self.step = 0;
            self.$router.options.routes.filter(item => item.path == '/consoleIndex')[0].children.filter(item => item
              .path == '/CompanyConsole/IndexEditShow')[0].meta.updataMark = true;
            //self.$router.options.routes[10].children[0].meta.updataMark = true;
            self.$message({
              showClose: true,
              message: `保存成功`,
              type: 'success'
            });
          } else {
            self.$message({
              showClose: true,
              message: `获取数据集列表失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },

      /*预览*/
      Preview() {
        /*sessionStorage.setItem('draggableScaleLevel', JSON.stringify(this.scaleLevel))
        sessionStorage.setItem('draggablePreview', JSON.stringify(this.draggable))*/
        if (this.isLook || !this.$store.state.functionList.includes('companyServiceDevice')) return;
        let self = this;
        let items = [];

        for (let a of this.mouldBox) {
          for (let b of a.children) {
            if (a.name != 'left_center') {
              items.push({
                type: 1,
                value: this[a.name][b.name].toString()
              })
            }
          }
        }
        /*添加系统运行状态关联属性*/
        if (self.DeviceData.length != 0) {
          let specs = this.DeviceOptions.filter(i => i.code == self.DeviceData[1].split('-')[1])[0].children.filter(p => p.id == self.DeviceData[1])[0].dataType.specs;
          let attr = {
            specs: specs,
            arr: self.DeviceData
          }
          items.push({
            type: 6,
            value: JSON.stringify(attr)
          })
        }
        sessionStorage.setItem('indexEditPreviewItem', JSON.stringify(items))
        sessionStorage.setItem('indexEditPreviewMouldId', JSON.stringify(self.mouldId))
        sessionStorage.setItem('indexEditPreviewType', JSON.stringify(self.type))
        // let routerMyCard = this.$router.resolve({
        // 	path: '/CompanyConsole/IndexEditShow'
        // })

        // let reg = new RegExp('/dist')
        // routerMyCard.href = routerMyCard.href.replace(reg,"")
        // window.open( routerMyCard.href+'?type=preview', 'indexEditPreview'+this.$store.state.companyId)
        this.windowOpen('/CompanyConsole/IndexEditShow', 'indexEditPreview' + this.$store.state.companyId,
          '?type=preview')
      },

      /*切换模板*/
      mouldChange(id) {
        if (this.isLook || !this.$store.state.functionList.includes('companyServiceDevice')) return;
        /*if(this.step != 0){
        	this.$confirm('当前编辑的模板尚未保存，是否确定离开?', '提示', {
        		confirmButtonText: '确定',
        		cancelButtonText: '取消',
        		type: 'warning'
        	}).then(() => {
        		this.mouldId = id;
        		this.step = 0;
        	})
        }else{
        	this.mouldId = id;
        	this.step = 0;
        }*/
        if(id==8){
          this.DeviceOptions.unshift(this.VirtualDevice)
          this.$parent.changeHeight(880)
        }
        if(this.mouldId==8&&id!=8){
          this.DeviceOptions.splice(0,1)
          this.$parent.changeHeight(694)
        }
        this.mouldId = id;
      },

      /*跳转编辑器*/
      goEditor() {
        if (!this.functionList.includes('companyServiceEditor') || this.isLook || !this.$store.state.functionList.includes('companyServiceDevice')) return;
        if (this.VerifyArr.includes(11)) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        // let  routerMyCard = this.$router.resolve({ path: '/CompanyConsole/mapEditor'})
        // let reg = new RegExp('/dist')
        // routerMyCard.href = routerMyCard.href.replace(reg,"")
        // window.open( routerMyCard.href,'mapEditor'+this.$store.state.companyId)
        this.windowOpen('/CompanyConsole/mapEditor', 'mapEditor' + this.$store.state.companyId)
      },
    },
    watch: {
      step(val) {
        this.$store.state.indexEditStep = val;
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.step != 0) {
        this.$confirm('当前编辑的版本尚未保存，是否确定离开?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          next();
        }).catch(err => {
          //设置头部
          this.$store.state.headerActive = 5;
        })
      } else {
        next();
      }
    },
    beforeDestroy() {
      if (this.getCompanyCode) {
        clearInterval(this.getCompanyCode); // 在Vue实例销毁前，清除我们的定时器
      }
    },
  }
</script>
<style scoped>
  .img-item{
    width: 80px;
    padding: 10px 5px;
    height: 100px;
    text-align: center;
    box-sizing: border-box;
  }
  .img-item:hover{
    background-color: #F0F7FF;
  }
  .img-item img{
    max-width: 50px;
    max-height: 50px;
  }
  .img-item p{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    line-height: 40px;
    font-size: 12px;
    color: #606266;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .imageBox{
    padding: 10px;
    width: 250px;
    height: 290px;
    overflow: hide;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    background: #fff;
    box-shadow: 0 0 5px 2px #eee;
    left: 40%;
    top:30%;
    border-radius: 15px;
    z-index: 99;
  }
  .imageBox .close{
    position: absolute;
    top: -14px;
    right: 12px;
  }
  .imageBox .img-list{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    height: 255px;
    overflow: auto;
  }
  .close-img {
    width: 14.5px;
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 2px;
  }
  .img-mask{
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background: transparent;
    z-index: 98;
  }
  .scroll {
    width: 100%;
    height: 58%;
    max-height: 58% !important;
    display: flex;
    justify-items: center;
    align-items: center;
    flex-wrap: wrap;
    overflow-y: auto;
  }

  .list-title {
    font-weight: bold;
    text-align: left;
    width: 100%;
    font-size: 17px;
    padding: 0 0 10px 0;
    box-sizing: border-box;
  }

  /* 模板8 */
  .mould8 {
    padding: 22px 30px;
    height: 100%;
    box-sizing: border-box;
  }

  .left-box {
    width: 55%;
    height: 100%;
  }

  .devices-box {
    width: 30%;
    align-self: stretch;
    background-color: #fff;
    margin: 0 21px 21px 0;
    padding: 15px 10px;
    box-sizing: border-box;
    border-radius: 15px;
    /* height: 250px; */
    box-shadow: 0 10px 20px 0 rgba(0, 173, 227, .15);
  }

  .datas-box {
    width: 30%;
    background-color: #fff;
    margin: 0 21px 21px 0;
    padding: 20px 10px;
    box-sizing: border-box;
    border-radius: 15px;
    height: 82px;
    box-shadow: 0 7px 20px 0 rgba(0, 173, 227, .15);
  }

  .top-20 {
    margin-top: 20px;
  }

  .centent-box,
  .right-box {
    height: 100%;
    width: 18%;
    display: flex;
    justify-items: center;
    align-content: baseline;
    flex-wrap: wrap;
    margin-left: 20px;
  }

  .sulv-box,
  .sulv-box2,
  .sulv-box3 {
    width: 100%;
    background-color: #fff;
    margin: 0 21px 21px 0;
    padding: 20px 10px;
    box-sizing: border-box;
    border-radius: 15px;
    height: 378px;
    box-shadow: 0 15px 30px 0 rgba(0, 173, 227, .15);
  }

  .sulv-box3 {
    height: 42%;
    overflow: auto;
  }

  .sulv-box2 {
    height: 320px;
    overflow: auto;
  }

  .settings_box_content .content_body>>>.el-cascader .el-input__inner {
    height: 37px !important;
  }

  .content_body>>>.el-cascader .el-cascader__tags span:first-child span:first-child {
    max-width: 40px;
    text-indent: 2.5px;
  }

  .content_body>>>.el-cascader .el-cascader__tags span:first-child i {
    left: 0px;
    top: 1.4px;
    background-color: #252626 !important;
    border: 1px solid rgba(112, 112, 112, .8);
    text-indent: -1px;
    line-height: 16px;
  }

  .settings_box_content .content_body>>>.el-cascader {
    /*margin-top: 10px;*/
    line-height: unset;
    position: relative;
    top: 6px;
    cursor: pointer;
    text-indent: 0;
  }

  .content_body>>>.el-cascader .el-cascader__tags .el-tag:not(.is-hit) {
    margin: 0;
    padding: 0px;
    border-radius: 1px;
    margin-left: 5px;
    background-color: #252626;
    border: 1px solid rgba(112, 112, 112, .8);
    cursor: pointer;
    margin-bottom: 1px;
  }
  .device-img-input{
    height: 32px;
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    text-align: left;
    display: inline-block;
    font-size: inherit;
    line-height: 32px;
    outline: 0;
    padding: 0 20px 0 10px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
  }
  .disable-img{
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
    cursor: not-allowed
  }
  .content_body {
    width: 190px;
    height: 50px;
    float: left;
    position: relative;
    top: -3px;
  }

  .settings_box_content .content_name {
    line-height: 50px;
    height: 50px;
    text-align: right;
    float: left;
    font-size: 17px;
    color: #606266;
    font-weight: 600;
  }

  .settings_box_content {
    float: left;
    width: 100%;
    height: auto;
  }

  .AlarmCount {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    height: max-content;
    font-size: 15px;
  }

  .right_last_ {
    height: 100%;
    position: relative;
    background-color: #fff;
    box-shadow: 0 42px 53px 0 rgba(0, 173, 227, .15);
    border-radius: 15px;
    flex: 1;
    margin-right: 20px;
  }


  .show_content .left .left_bottom .choice_data {
    width: 260px !important;
    margin-left: auto !important;
  }

  .left .choice_data>>>.el-input,
  .right4_left .choice_data>>>.el-input,
  .right_last .choice_data>>>.el-input {
    width: 100% !important;
  }

  .left .choice_data>>>.el-input__inner,
  .right4_left .choice_data>>>.el-input__inner,
  .right_last .choice_data>>>.el-input__inner {
    width: 100% !important;
  }

  .left .choice_data>>>.el-form-item__content,
  .right4_left .choice_data>>>.el-form-item__content,
  .right_last .choice_data>>>.el-form-item__content {
    width: calc(100% - 80px) !important;
  }

  .left .choice_data>>>.el-input__inner,
  .right4_left .choice_data>>>.el-input__inner,
  .right_last .choice_data>>>.el-input__inner {
    width: 100% !important;
  }

  .left .choice_data,
  .right4_left .choice_data,
  .right_last .choice_data {
    width: calc(100% - 7px) !important;
    margin-left: 7px;
  }

  .right4_right {
    flex: 1;
    margin-left: 20px;
  }

  .right4_left {
    flex: .5;
  }

  .right4_ {
    height: 100%;
    position: relative;
    background-color: #fff;
    box-shadow: 0 42px 53px 0 rgba(0, 173, 227, .15);
    border-radius: 15px;
  }

  .choice_data {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    width: 260px;
    height: max-content;
  }
.height-32{
  height: 32px;
  margin-top: 10px;
}


  .right_bottom_ {
    position: absolute;
    bottom: -1px;
    right: -1px;
    width: 19px;
    height: 19px;
    border-bottom: 3px solid #379BAA;
    border-right: 3px solid #379BAA;
  }

  .left_bottom_ {
    position: absolute;
    bottom: -1px;
    left: -1px;
    width: 19px;
    height: 19px;
    border-bottom: 3px solid #379BAA;
    border-left: 3px solid #379BAA;
  }

  .right_top_ {
    position: absolute;
    top: -1px;
    right: -1px;
    width: 19px;
    height: 19px;
    border-top: 3px solid #379BAA;
    border-right: 3px solid #379BAA;
  }

  .left_top_ {
    position: absolute;
    top: -1px;
    left: -1px;
    width: 19px;
    height: 19px;
    border-top: 3px solid #379BAA;
    border-left: 3px solid #379BAA;
  }

  .backgroundBy456 .choice_data>>>.el-form-item__label {
    color: #fff !important;
  }

  .backgroundBy456 .choice_data>>>.el-input__inner {
    border: 1px solid rgba(83, 83, 83, 1) !important;
    color: #fff !important;
  }

  .backgroundBy456 .left_top .top-box {
    background: rgba(12, 25, 42, 0.2) !important;
    border: 2px solid rgba(18, 39, 68, 1) !important;
    border-radius: 0 !important;
    box-shadow: unset !important;
  }

  .backgroundBy456 .right_ {
    background: rgba(12, 25, 42, 0.2) !important;
    border: 2px solid rgba(18, 39, 68, 1) !important;
    border-radius: 0 !important;
    box-shadow: unset !important;
  }

  .backgroundBy456 .bottom-box {
    border-radius: 0 !important;
    background: rgba(12, 25, 42, 0.2) !important;
    border: 2px solid rgba(18, 39, 68, 1) !important;
    box-shadow: unset !important;
  }

  .backgroundBy456 .center-box {
    border-radius: 0 !important;
  }

  .backgroundBy456 {
    background-image: url(../../assets/image/indexEditor/mould/background456.png);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  i.close {
    font-size: 20px;
    float: right;
    margin-top: 24px;
  }

  .popupT>div {
    position: fixed !important;
    top: 10%;
    left: 50%;
    padding: 0 28px;
    box-sizing: border-box;
    margin-left: -407px;
    width: 578px;
    background-color: #fff;
    z-index: 9999;
    padding-bottom: 30px;
  }

  .popupT-title {
    font-size: 16px;
    line-height: 64px;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 22px;
    text-align: left;
  }

  .popupT-lab {
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 14px;
  }

  .btn-box {
    position: relative;
    margin-top: 260px;
  }

  .btn-box2 {
    text-align: center;
    width: 100%;
    margin-top: 46px;
  }

  .btn-box>p {
    margin-top: 10px;
    color: #909090;
  }


  .OneDataSet .choice_data {
    height: 34px !important;
  }

  .robotname {
    line-height: 34px;
  }

  .choice_data>>>.el-input {
    width: 183px;
    height: 34px;
    line-height: 34px;
  }

  .choice_data>>>.el-input__inner {
    width: 183px;
    height: 34px;
    line-height: 34px;
    border-radius: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-color: transparent;
  }

  .choice_data>>>.el-input__icon {
    line-height: 34px;
    height: 34px;
  }

  .choice_data>>>.el-form-item {
    margin-bottom: 11px !important;
  }

  .choice_data>>>.el-select {
    /*width: 100%;*/
  }

  .choice_data>>>.el-form-item__content {
    width: 183px !important;
    top: 0 !important;
    float: left;
  }

  .choice_data>>>.el-form-item__label {
    line-height: 34px !important;
    float: left;
  }


  #el-formAdd {
    position: relative;
    width: 100%;
    height: calc(100% - 60px);
    min-width: 1071px;
    min-height: 700px;
  }

  .left_top_2 .top-box,
  .left_top_3 .top-box {
    background: #fff;
    box-shadow: 0 15px 30px 0 rgba(0, 173, 227, .15);
    border-radius: 15px;
    flex: 1;
    margin-right: 21px;
    height: 100%;
    position: relative;
  }

  .left_top .top-box {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 15px 30px 0px rgba(0, 173, 227, 0.15);
    border-radius: 15px;
    flex: 1;
    margin-right: 21px;
    height: calc(100% - 52px);
    margin-top: 22px;
    position: relative;
  }

  .left_top_2,
  .left_top_3 {
    width: calc(100% - 33px);
    margin: 0 0 0 33px;
    display: flex;
  }

  .left_top {
    width: calc(100% - 64px);
    margin: 0 31px 0 33px;
    display: flex;
  }

  .right_ {
    width: calc(100% - 64px);
    height: 100%;
    background-color: #fff;
    box-shadow: 0px 42px 53px 0px rgba(0, 173, 227, 0.15);
    border-radius: 15px;
    margin-top: 30px;
    margin-left: 34px;
    transition: .3s;
    position: relative;
  }

  .bottom-box {
    width: calc(100% - 34px);
    height: calc(100% - 90px);
    background-color: #fff;
    box-shadow: 0px 42px 53px 0px rgba(0, 173, 227, 0.15);
    margin: 30px 0 60px 34px;
    border-radius: 15px;
    position: relative;
  }

  .center-box {
    width: calc(100% - 35px);
    height: calc(100% - 2px);
    margin: 0 0 0 33px;
    border: 1px dashed rgba(180, 180, 180, 1);
    border-radius: 15px;
    text-indent: 11px;
    letter-spacing: 2px;
  }

  .right1 {
    flex: .5;
    margin-top: 41px !important;
  }

  .right2 {
    flex: .5;
  }

  .right3 {
    flex: 1;
    margin-top: 41px !important;
  }

  .right4 {
    flex: 1;
    margin-top: 41px !important;
    display: flex;
    width: calc(100% - 64px);
    margin-left: 34px;
    transition: .3s;
  }

  .right_last {
    flex: 1;
    margin-top: 41px !important;
    display: flex;
    width: calc(100% - 64px);
    margin-left: 34px;
    transition: .3s;
  }

  .right_center {
    flex: 1;
  }

  .right_bottom {
    flex: 1;
  }


  .left_bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 280px;
    transition: .3s;
  }

  .left_center {
    position: absolute;
    bottom: 280px;
    left: 0;
    right: 0;
    top: 160px;
    margin: auto;
    font-size: 24px;
    font-weight: bold;
    color: rgba(79, 135, 227, 1);
    transition: .3s;
  }

  .left_top_3 {
    top: 154px !important;
  }

  .left_top_2,
  .left_top_3 {
    position: absolute;
    top: 41px;
    left: 0;
    height: 94px;
    transition: .3s;
  }



  .left_top {
    position: absolute;
    top: 0;
    left: 0;
    /* margin: auto; */
    height: 160px;
    transition: .3s;
  }

  .left {
    position: absolute;
    left: 0;
    right: 360px;
    bottom: 0;
    top: 0;
    margin: auto;
    text-align: left;
    transition: .3s;
  }

  .right {
    width: 360px;
    position: absolute;
    right: 0;
    bottom: 60px;
    top: 0;
    display: flex;
    flex-flow: column;
    margin: auto;
    transition: .3s;
  }

  .ButtonNoset {
    background-color: #a0cfff !important;
    border-color: #a0cfff !important;
    cursor: not-allowed !important;
  }


  .show_content {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .right_header span {
    position: absolute;
    bottom: 8px;
    left: 0;
    right: 0;
    margin: auto;
  }

  .right_header {
    float: right;
    color: #606060;
    width: 24px;
    height: 59px;
    font-size: 12px;
    text-align: center;
    position: relative;
    margin-right: 38px;
    cursor: pointer;
    transition: .1s;
  }

  .preview {
    background: url(../../assets/image/indexEditor/perview.png)no-repeat center;
    background-position-y: 12px;
  }

  .preview.isLook {
    background: url(../../assets/image/indexEditor/perviewHover.png)no-repeat center;
    background-position-y: 12px;
    color: #bcbcbc;
  }

  .preview:hover {
    background: url(../../assets/image/indexEditor/perviewHover.png)no-repeat center;
    background-position-y: 12px;
    color: #bcbcbc;
  }

  .save {
    background: url(../../assets/image/indexEditor/save.png)no-repeat center;
    background-position-y: 12px;
  }

  .save.isLook {
    background: url(../../assets/image/indexEditor/saveHover.png)no-repeat center;
    background-position-y: 12px;
    color: #bcbcbc;
  }

  .save:hover {
    background: url(../../assets/image/indexEditor/saveHover.png)no-repeat center;
    background-position-y: 12px;
    color: #bcbcbc;
  }

  .show_header {
    width: 100%;
    height: 59px;
    background-color: #fff;
    border-bottom: 1px solid rgba(229, 229, 229, 1);
    min-width: 440px;
  }

  .mould_show {
    width: calc(100% - 311px);
    height: 100%;
    position: relative;
    background-color: #F5F5F6;
    float: left;
  }

  .ely-preview {
    background-color: #5088E4;
    color: #fff;
    width: 109px;
    letter-spacing: 1px;
    font-size: 15px;
    cursor: pointer;
    border: 0;
    border-radius: 2px;
    height: 34px;
    line-height: 33px;
    float: left;
    margin-top: 12px;
    margin-left: 32px;
  }

  .mould_box .box_title {
    text-align: center;
    line-height: 35px;
    color: #373737;
    font-size: 12px;
    float: left;
    width: 100%;
  }

  .mould_box .box_img {
    width: 100%;
    height: 133px;
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    float: left;
    border-top: 1px solid rgba(220, 220, 220, 1);
  }

  .mould_box:hover {
    outline: 2px solid #5087E4 !important;
  }

  .mould_box.active {
    outline: 2px solid #5087E4 !important;
  }

  .mould_box {
    width: calc(100% - 81px);
    float: left;
    margin: 2px 28px 37px 28px;
    padding: 10px 12px 0 13px;
    cursor: pointer;
    background: rgba(255, 255, 255, 1);
    outline: 1px solid rgba(220, 220, 220, 1);
    transition: .1s;
  }

  .overAuto {
    width: 100%;
    height: calc(100% - 49px);
    float: left;
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .choice_title {
    color: #383838;
    line-height: 49px;
    text-indent: 23px;
    text-align: left;
    float: left;
    width: 100%;
    font-size: 14px;
  }

  .overAuto::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #f5f7fa;
  }

  /*滚动条的轨道*/

  .overAuto::-webkit-scrollbar-track {
    /*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
    background-color: #fff;
  }

  /*滚动条的滑块按钮*/

  .overAuto::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #DCDCDC;
    /*box-shadow: inset 0 0 5px #000;*/
    /*box-shadow: 8px 0 0 #A5ADB7 inset;*/
  }

  /*滚动条的上下两端的按钮*/

  .overAuto::-webkit-scrollbar-button {
    height: 0px;
    background-color: #eee;
  }

  .mould_choice {
    float: left;
    width: 309px;
    height: 100%;
    background: #FFFFFF;
    border-right: 1px solid #DCDCDC;
    min-height: 705px;
  }

  .indexEdit {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .clearfix:after {
    content: "";
    display: block;
    clear: both;
  }

  * {
    -webkit-touch-callout: none;
    /*系统默认菜单被禁用*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -khtml-user-select: none;
    /*早期浏览器*/
    -moz-user-select: none;
    /*火狐*/
    -ms-user-select: none;
    /*IE10*/
    user-select: none;
  }
</style>
<style>
  #indexEdit  .el-form-item {
    margin-bottom: 5px !important;
  }

  #indexEdit .el-form-item__label{
    padding-right: 0 !important;
  }
  #indexEdit .device-img-input .el-input__inner,#indexEdit .height-32 .el-form-item__content{
    line-height: 32px !important;
    height: 32px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexEdit/indexEdit.vue